import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

function Login() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    try {
      const { data, error } = await supabase.auth.signInWithPassword({ password })

      console.log('login data:', data)
      console.log('login error:', error)

      if (error) {
        setError(error.message)
        setLoading(false)
      }
    } catch (err) {
      console.error('unexpected error:', err)
      setError('Unexpected error. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoMark}>Test Org</div>
        </div>
        <p style={styles.subtitle}>Tessitura Management Portal</p>
        <div style={styles.ssoChip}>Microsoft Entra SSO supported</div>
        <p style={styles.ssoNote}>Sign in with your work Outlook account.</p>
        <div style={styles.mobileBanner}>
          <span style={styles.mobileBannerLabel}>Mobile build in progress</span>
          <span style={styles.mobileBannerText}>Screen, segment, and clean constituent data on the go.</span>
        </div>

        <form onSubmit={handleLogin}>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoFocus
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
    padding: '20px',
    background: '#f0f7ff',
    backgroundImage: 'linear-gradient(rgba(29,111,219,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(29,111,219,0.06) 1px, transparent 1px)',
    backgroundSize: '60px 60px',
  },
  card: {
    backgroundColor: 'rgba(255,255,255,0.88)',
    backdropFilter: 'blur(24px) saturate(180%)',
    WebkitBackdropFilter: 'blur(24px) saturate(180%)',
    padding: '48px',
    borderRadius: '16px',
    boxShadow: '0 4px 40px rgba(29,111,219,0.12)',
    border: '1px solid rgba(29,111,219,0.14)',
    width: '100%',
    maxWidth: '420px',
    boxSizing: 'border-box',
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '24px',
  },
  logoMark: {
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: '28px',
    fontWeight: '700',
    color: '#0c1a33',
    letterSpacing: '-0.02em',
    padding: '14px 18px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, rgba(29,111,219,0.09), rgba(56,189,248,0.14))',
    border: '1px solid rgba(29,111,219,0.16)',
  },
  subtitle: {
    fontSize: '14px',
    color: '#4b5563',
    textAlign: 'center',
    marginBottom: '12px',
  },
  ssoChip: {
    display: 'block',
    width: 'fit-content',
    margin: '0 auto 8px',
    padding: '6px 10px',
    borderRadius: '999px',
    backgroundColor: '#f0f7ff',
    border: '1px solid rgba(29,111,219,0.16)',
    color: '#1d6fdb',
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: "'Inter', sans-serif",
  },
  ssoNote: {
    margin: '0 0 16px',
    textAlign: 'center',
    color: '#6b7280',
    fontSize: '12px',
    fontFamily: "'Inter', sans-serif",
  },
  mobileBanner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '26px',
    padding: '12px 14px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, rgba(29,111,219,0.08), rgba(56,189,248,0.1))',
    border: '1px solid rgba(29,111,219,0.16)',
  },
  mobileBannerLabel: {
    color: '#0c1a33',
    fontSize: '12px',
    fontWeight: '800',
    fontFamily: "'Inter', sans-serif",
  },
  mobileBannerText: {
    color: '#4b5563',
    fontSize: '12px',
    lineHeight: '1.45',
    fontFamily: "'Inter', sans-serif",
  },
  field: {
    marginBottom: '20px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#0c1a33',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1px solid rgba(29,111,219,0.22)',
    backgroundColor: '#fff',
    color: '#0c1a33',
    fontSize: '14px',
    fontFamily: "'Inter', sans-serif",
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '13px',
    background: 'linear-gradient(135deg, #1d6fdb, #38bdf8)',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '600',
    fontFamily: "'Inter', sans-serif",
    cursor: 'pointer',
    marginTop: '8px',
    boxShadow: '0 4px 24px rgba(29,111,219,0.28)',
  },
  error: {
    color: '#dc2626',
    fontSize: '13px',
    marginBottom: '12px',
  },
  forgotLink: {
    fontSize: '13px',
    color: '#1d6fdb',
    textAlign: 'center',
    marginTop: '16px',
    cursor: 'pointer',
  }
}

export default Login
